export const splitAmount = (num: number) => String(Number(num)).replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1 ')
